angular.module('acquisition-source')
    .component('acquisitionSourcePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: "<?",
            activeOnly: "<?",
            onChange: "&"
        },
        templateUrl: "app/acquisition-source/picker/picker.html",
        controller: function(AcquisitionSource, AcquisitionSourceService) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.activeOnly = ctrl.activeOnly != null ? ctrl.activeOnly : true;

                ctrl.loadItems()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
            ctrl.loadItems = () => {
                let selectedId = ctrl.ngModel ? ctrl.ngModel?.id : null
                let filters = {activeOnly: ctrl.activeOnly, selectedId: selectedId}
                return AcquisitionSource.autocomplete(filters).$promise.then(items => ctrl.items = items);
            }

            ctrl.add = () => AcquisitionSourceService.add().then(() => ctrl.loadItems());
            ctrl.list = () => AcquisitionSource.autocomplete().then(() => ctrl.loadItems());
        }
    })
